import styled from "styled-components";

const StyledInput = styled.input`
	background: #aaa;
	font-size: 24px;
	height: 30px;
`;

export default StyledInput;
